import axios from "@/axios";

export function trainerLogin(data) {
  return axios.post("/api/trainer/login", data);
}

export function fetchTrainerMe() {
  return axios.get("/api/trainer/me");
}

export function trainerLogout() {
  return axios.post("/api/trainer/logout");
}



// 🟢 جلب طلاب المدرّب
export async function fetchStudents() {
  const res = await axios.get("/api/trainer/students");
  return res.data;
}

// 🟢 إنشاء طالب
export async function createStudent(data) {
  const res = await axios.post("/api/trainer/students", data);
  return res.data;
}

// ================= Contacts (Trainer) =================
export async function fetchTrainerContacts() {
  const res = await axios.get("/api/trainer/contacts");
  return res.data.contacts; // ✅ نفس academy
}

export async function createTrainerContact(data) {
  const res = await axios.post("/api/trainer/contacts", data);
  return res.data.contact;
}

export async function updateTrainerContact(id, data) {
  const res = await axios.put(`/api/trainer/contacts/${id}`, data);
  return res.data.contact;
}

export async function deleteTrainerContact(id) {
  await axios.delete(`/api/trainer/contacts/${id}`);
}



// 🟢 جلب كل الكورسات الخاصة بالمدرب
export async function fetchTrainerCourses() {
  const res = await axios.get("/api/trainer/courses");
  return res.data.courses;
}

// 🟢 إنشاء كورس جديد (مصَحّح)
export async function createTrainerCourse(data) {
  const formData = new FormData();

  Object.keys(data).forEach((key) => {
    // 🔥 faqs (array of objects)
    if (key === "faqs") {
      data.faqs.forEach((faq, i) => {
        if (faq.question && faq.answer) {
          formData.append(`faqs[${i}][question]`, faq.question);
          formData.append(`faqs[${i}][answer]`, faq.answer);
        }
      });
    }

    // 🔹 arrays عادية (requirements, outcomes)
    else if (Array.isArray(data[key])) {
      data[key].forEach((v, i) => {
        if (v !== "" && v !== null) {
          formData.append(`${key}[${i}]`, v);
        }
      });
    }

    // 🔹 قيم عادية + ملفات
    else if (data[key] !== null && data[key] !== undefined) {
      formData.append(key, data[key]);
    }
  });

  // 🧪 (اختياري للتجربة)
  // for (let pair of formData.entries()) {
  //   console.log(pair[0], pair[1]);
  // }

  const res = await axios.post("/api/trainer/courses", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return res.data.course;
}

// 🟢 حذف كورس
export async function deleteTrainerCourse(id) {
  await axios.delete(`/api/trainer/courses/${id}`);
}

// 🟢 جلب الفئات (رئيسية + فرعية)
export async function fetchCategories() {
  const res = await axios.get("/api/trainer/categories");
  return res.data.categories;
}

// 🟢 جلب سكشنات كورس
export async function fetchCourseSections(courseId) {
  const res = await axios.get(
    `/api/trainer/courses/${courseId}/sections`
  );
  return res.data.sections;
}

// 🟢 إضافة سكشن جديد
export async function createCourseSection(courseId, data) {
  const res = await axios.post(
    `/api/trainer/courses/${courseId}/sections`,
    data
  );
  return res.data.section;
}

// 🟢 حذف سكشن
export async function deleteCourseSection(sectionId) {
  await axios.delete(`/api/trainer/sections/${sectionId}`);
}

// 🟢 إعادة ترتيب السكشنات
export async function reorderCourseSections(courseId, orders) {
  await axios.post(
    `/api/trainer/courses/${courseId}/sections/reorder`,
    { orders }
  );
}

// 🟢 إضافة فيديو لسكشن (رابط Bunny فقط)
export async function createCourseVideo(sectionId, data) {
  const res = await axios.post(
    `/api/trainer/sections/${sectionId}/videos`,
    data
  );
  return res.data.video;
}

// 🟢 حذف فيديو
export async function deleteCourseVideo(videoId) {
  await axios.delete(`/api/trainer/videos/${videoId}`);
}

// 🟢 إعادة ترتيب الفيديوهات داخل سكشن
export async function reorderCourseVideos(sectionId, orders) {
  await axios.post(
    `/api/trainer/sections/${sectionId}/videos/reorder`,
    { orders }
  );
}


// 🟢 رفع فيديو إلى Bunny (عبر Laravel)
export async function uploadTrainerVideo(file) {
  const formData = new FormData();
  formData.append("video", file);

  const res = await axios.post(
    "/api/trainer/upload-video",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return res.data.video_url; // رابط Bunny
}



// 🟢 توليد سكشنات الكورس بالذكاء الاصطناعي
export async function generateCourseSectionsAI(courseId) {
  const res = await axios.post(
    `/api/trainer/courses/${courseId}/generate-sections-ai`
  );
  return res.data.sections;
}


// 🟢 توليد أسماء فيديوهات السكشن بالذكاء الاصطناعي (بدون رابط)
export async function generateSectionVideosAI(sectionId) {
  const res = await axios.post(
    `/api/trainer/sections/${sectionId}/generate-videos-ai`
  );
  return res.data.videos;
}


// 🟢 توليد وصف فيديو واحد بالذكاء الاصطناعي
export async function generateVideoDescriptionAI(videoId) {
  const res = await axios.post(
    `/api/trainer/videos/${videoId}/generate-description-ai`
  );
  return res.data.description;
}


// 🟢 توليد صورة مصغّرة للفيديو بالذكاء الاصطناعي
export async function generateVideoThumbnailAI(videoId) {
  const res = await axios.post(
    `/api/trainer/videos/${videoId}/generate-thumbnail-ai`
  );
  return res.data.thumbnail_url;
}


// 🟢 رفع صورة مصغّرة يدويًا
export async function uploadVideoThumbnail(videoId, file) {
  const formData = new FormData();
  formData.append("thumbnail", file);

  const res = await axios.post(
    `/api/trainer/videos/${videoId}/thumbnail`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return res.data.thumbnail_url;
}

// 🔴 حذف صورة مصغّرة
export async function deleteVideoThumbnail(videoId) {
  await axios.delete(`/api/trainer/videos/${videoId}/thumbnail`);
}

// 🟢 إرجاع رابط صورة الفيديو (إن وجد)
export function getVideoThumbnail(video) {
  return video?.thumbnail_url || null;
}


/**
 * 🟢 جلب صفحة المدرّب
 */
export async function fetchTrainerPage(trainerId) {
  const res = await axios.get(`/api/public/trainers/${trainerId}`);
  return res.data;
}


/**
 * 🟢 جلب تفاصيل الكورس
 */
export async function fetchCoursePage(courseId) {
  const res = await axios.get(`/api/public/courses/${courseId}`);
  return res.data;
}


// 🟢 توليد أكواد تفعيل للكورس (Trainer)
export async function generateCourseActivationCodes(courseId, count) {
  const res = await axios.post(
    `/api/trainer/courses/${courseId}/activation-codes`,
    {
      course_id: courseId,
      count: count,
    }
  );

  return res.data;
}
